import { useCallback, useEffect, useState } from 'react'

interface Config {
    isValidating: boolean
    tabItemSelector: string
    keyProp?: 'id' | 'href'
    decorateSelected?: boolean
}

const useTabsControl = ({
    isValidating,
    tabItemSelector,
    keyProp = 'id',
    decorateSelected = false
}: Config): string => {
    const [selectedTabKey, setSelectedTabKey] = useState('')

    const onTabItemClick = useCallback(
        (e: Event) => {
            const selectedElement = e.target as HTMLAnchorElement
            setSelectedTabKey(selectedElement[keyProp])
        },
        [keyProp]
    )

    useEffect(() => {
        if (!selectedTabKey || !decorateSelected) return

        const tabItems =
            document.querySelectorAll<HTMLAnchorElement>(tabItemSelector)

        const selected = [...tabItems].find(
            (tab) => tab[keyProp] === selectedTabKey
        )

        const nonSelected = [...tabItems].filter(
            (tab) => tab[keyProp] !== selectedTabKey
        )

        nonSelected.forEach((tab) =>
            tab.classList.remove('decorated-menu-item')
        )

        selected?.classList?.toggle('decorated-menu-item', decorateSelected)
    }, [keyProp, decorateSelected, tabItemSelector, selectedTabKey])

    useEffect(() => {
        const tabItems = document.querySelectorAll<HTMLElement>(tabItemSelector)

        tabItems.forEach((item) =>
            item.addEventListener('click', onTabItemClick)
        )

        return () =>
            tabItems.forEach((item) =>
                item.removeEventListener('click', onTabItemClick)
            )
    }, [onTabItemClick, isValidating, tabItemSelector])

    return selectedTabKey
}

export default useTabsControl
